<template>
  <div class="form-box">
    <el-form
      ref="form"
      :hide-required-asterisk="true"
      label-position="top"
      :rules="rules"
      label-width="200px"
      :model="form"
    >
      <vue-dividing-line title="家長帳號信息"></vue-dividing-line>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item prop="email">
            <div slot="label">
              <div class="label-text">
                電郵地址 <span class="star-mark">*</span>
              </div>
            </div>
            <el-input
              v-model="form.email"
              :disabled="userInfoRoleRoleId ==teacherRoleId"
              placeholder="請輸入電郵"
              class="fixed-with-330-input"
            >
            </el-input>
          </el-form-item>
          <el-form-item>
            <div slot="label">
              <div class="label-text">
                電話
               
              </div>
            </div>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item>
                  <el-select
                    class="fixed-with-330-input"
                    v-model="form.areaCode"
                    :disabled="userInfoRoleRoleId ==teacherRoleId"
                    placeholder=""
                  >
                    <el-option
                      v-for="item in areaCode"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="18">
                <el-form-item>
                  <el-input
                    v-model="form.phone"
                    :disabled="userInfoRoleRoleId ==teacherRoleId"
                    placeholder="請輸入電話"
                    class="fixed-with-330-input"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item>
            <div slot="label">
              <div class="label-text">
                用戶姓名
              
              </div>
            </div>
            <el-input
              v-model="form.name"
              :disabled="userInfoRoleRoleId ==teacherRoleId"
              placeholder="請輸入用戶姓名"
              class="fixed-with-330-input"
            >
            </el-input>
          </el-form-item>
          <el-form-item
           
            :rules="[{ required: true, message: '', trigger: 'blur' }]"
          >
            <div slot="label">
              <div class="label-text">
                帳號狀態
                <span class="star-mark">*</span>
              </div>
            </div>
              <el-select v-model="form.status" @change="onStatusChange" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <div class="label-text">&nbsp;&nbsp;地址</div>
        <el-col :span="6">
          <el-form-item>
            <div slot="label">
              <div class="label-text">國家</div>
            </div>
            <el-select :disabled="userInfoRoleRoleId ==teacherRoleId" v-model="form.country" placeholder="請選擇國家">
              <el-option
                v-for="(item, index) in nation"
                :key="index"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item>
            <div slot="label">
              <div class="label-text">區域</div>
            </div>
            <el-select :disabled="userInfoRoleRoleId ==teacherRoleId" v-model="form.area" placeholder="請選擇區域">
              <el-option
                v-for="(item, index) in region"
                :key="index"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item>
            <div slot="label">
              <div class="label-text">地區</div>
            </div>
            <el-select :disabled="userInfoRoleRoleId ==teacherRoleId" v-model="form.district" placeholder="請選擇地區">
              <el-option
                v-for="(item, index) in district"
                :key="index"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item>
        <div slot="label">
          <div class="label-text">詳細地址</div>
        </div>
        <el-input :disabled="userInfoRoleRoleId ==teacherRoleId" v-model="form.address" placeholder="請輸入詳細地址">
        </el-input>
      </el-form-item>
      <el-row :gutter="20" type="flex" justify="space-between">
        <el-col :span="12">
          <el-form-item prop="password">
            <div slot="label">
              <div class="label-text">
                密碼
                <span  class="star-mark">*</span>
              </div>
            </div>
            <el-input
              v-model="form.password"
              :disabled="userInfoRoleRoleId ==teacherRoleId"
              :class="showPassword?'':'password-hidden'"
              placeholder="請輸入密碼"
              class="fixed-with-330-input"
            >
            <i v-show="form.password"
                    class="el-icon-view el-input__icon"
                    slot="suffix"
                    @click="showPassword=!showPassword">
                  </i>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="confirmPassword">
            <div slot="label">
              <div class="label-text">
                確認密碼
                <span  class="star-mark">*</span>
              </div>
            </div>
            <el-input
              v-model="form.confirmPassword"
              :disabled="userInfoRoleRoleId ==teacherRoleId"
              :class="showConfirmPassword?'':'password-hidden'"
              @input="onConfirmPassword"
              placeholder="請輸入確認密碼"
              class="fixed-with-330-input"
            >
             <i v-show="form.confirmPassword"
                    class="el-icon-view el-input__icon"
                    slot="suffix"
                    @click="showConfirmPassword=!showConfirmPassword">
                  </i>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <vue-dividing-line title="學生帳號信息"></vue-dividing-line>
      <div
        class="student-account-information-row"
        v-for="(item, index) in form.students"
        :key="index"
      >
        <el-row type="flex" align="middle" justify="space-between" style="padding-bottom: 10px;">
          <el-col :span="4">
            <div class="page-title">學生</div>
          </el-col>
          <el-col :span="11" style="text-align: right;">
            <el-button
                size="mini" type="danger" round
                v-if="(index !== 0 || students.length > 1) && userInfoRoleRoleId !==teacherRoleId"
                @click="onDelete(item.id, index)"
            >
              <i class="el-icon-delete-solid"></i>刪除學生
            </el-button>
            <el-button size="mini" type="warning" @click="onSave(item)"  round>保存</el-button>
          </el-col>
        </el-row>
        <div style="display: flex;">
          <div style="flex: 1; display: flex; flex-direction: column;">
            <el-form-item
              class="flex-form-item"
              :prop="'students.' + index + '.userNo'"
              :rules="[{ required: true, message: '', trigger: 'blur' }]"
            >
              <div slot="label">
                <div class="label-text">
                  學生帳號
                  <span class="star-mark">*</span>
                </div>
              </div>
              <el-input
                v-model="item.userNo"
                placeholder="請輸入學生帳號"
                class="fixed-with-330-input"
              >
              </el-input>
            </el-form-item>
            <el-form-item
              class="flex-form-item">
              <div slot="label">
                <div class="label-text">
                  性別
                </div>
              </div>
              <el-select
                class="fixed-with-330-input"
                v-model="item.gender"
                clearable
                placeholder="請選擇性別"
              >
                <el-option
                  v-for="item in genders"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              class="flex-form-item"
              :prop="'students.' + index + '.grade'"
              :rules="[{ required: true, message: '', trigger: 'blur' }]"
            >
              <div slot="label">
                <div class="label-text">
                  年級
                  <span class="star-mark">*</span>
                </div>
              </div>
              <el-select
                class="fixed-with-330-input"
                v-model="item.grade"
                value-key="id"
                 @change="onBranchSchoolChange"
                clearable
                placeholder="請選擇年級"
              >
                <el-option
                  v-for="(item, index) in grades"
                  :key="index"
                  :label="item.name"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <div slot="label">
                <div class="label-text">頭像</div>
              </div>
              <div style="position: relative;">
                  <avatar-popover @avatarChange="avatarChange(index,$event)" :avatar="item.avatar"></avatar-popover>
              </div>
            </el-form-item>
          </div>
          <div
            style="
              margin: 0 20px;
              flex: 1;
              display: flex;
              flex-direction: column;
            "
          >
            <el-form-item>
              <div slot="label">
                <div class="label-text">
                  分校學生編號
                </div>
              </div>
              <el-input
                v-model="item.studentCode"
                placeholder="請輸入分校學生編號"
                class="fixed-with-330-input"
              >
              </el-input>
            </el-form-item>
            <el-form-item>
              <div slot="label">
                <div class="label-text">
                  生日日期
                
                </div>
              </div>
              <el-date-picker
                v-model="item.birthday"
                value-format="yyyy-MM-dd"
                class="fixed-with-330-input"
                :picker-options="pickerOptions"
                type="date"
                placeholder="請選擇日期"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item
              :prop="'students.' + index + '.password'"
              :rules="[{ required: true, message: '', trigger: 'blur' }]"
            >
              <div slot="label">
                <div class="label-text">
                  學生密碼
                  <span class="star-mark">*</span>
                </div>
              </div>
              <el-input
                show-password
                v-model="item.password"
                placeholder="請輸入學生密碼"
                class="fixed-with-330-input"
              >
              </el-input>
            </el-form-item>
            <el-form-item
              :prop="'students.' + index + '.status'"
              :rules="[{ required: true, message: '', trigger: 'blur' }]"
            >
              <div slot="label">
                <div class="label-text">
                  帳號狀態
                  <span class="star-mark">*</span>
                </div>
              </div>
               <el-select v-model="item.status" @change="onStudentsStatus(index, item.status)" class="fixed-with-330-input" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div style="flex: 1; display: flex; flex-direction: column;">
            <el-form-item>
              <div slot="label">
                <div class="label-text">
                  學生姓名
                  
                </div>
              </div>
              <el-input
                v-model="item.name"
                placeholder="請輸入學生姓名"
                class="fixed-with-330-input"
              >
              </el-input>
            </el-form-item>
            <el-form-item>
              <div slot="label">
                <div class="label-text">
                  分校
                </div>
              </div>
              <el-select
                class="fixed-with-330-input"
                v-model="item.branchSchool"
                value-key="id"
                @change="onBranchSchoolChange"
                clearable
                placeholder="請選擇分校"
              >
                <el-option
                  v-for="(item, index) in sortBranchesList"
                  :key="index"
                  :label="item.abbreviation"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              :prop="'students.' + index + '.confirmPassword'"
              :rules="[{ required: true, message: '', trigger: 'blur' }]"
            >
              <div slot="label">
                <div class="label-text">
                  學生確認密碼
                  <span class="star-mark">*</span>
                </div>
              </div>
              <el-input
                show-password
                @input="onConfirmPassword"
                v-model="item.confirmPassword"
                placeholder="請再次輸入學生密碼"
                class="fixed-with-330-input"
              >
              </el-input>
            </el-form-item>
            <el-form-item>
              <div slot="label">
                <div class="label-text">
                  語言
                </div>
              </div>
              <el-select v-model="item.studying" class="fixed-with-330-input" placeholder="请选择">
                <!-- value 改为数字 0/1，而非字符串 -->
                <el-option label="繁" :value="0">繁</el-option>
                <el-option label="En" :value="1">En</el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
        <el-row v-if="item.id">
          <el-col>
            <span
              class="text-line-button cursor-pointer"
              @click="onAddSubscribe(item)"
            >
              <i class="el-icon-circle-plus-outline"></i>新增訂閱
            </span>
          </el-col>
        </el-row>
        <div class="subscribe-box" v-if="item.subscriptions && item.subscriptions.length">
          <div class="subscribe-title">訂閱進度</div>
          <el-table :data="item.subscriptions">
            <el-table-column prop="gradeName" label="年級"> </el-table-column>
            <el-table-column label="訂閱狀態">
              <template slot-scope="{ row }">
                <subscriptionStatus :subscriptionItem="row"></subscriptionStatus>
              </template>
            </el-table-column>
            <el-table-column label="訂閱時段">
              <template slot-scope="{ row }">
                <span>{{ row.startDate | formatDate }}</span>--<span>{{ row.endDate | formatDate }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="type" label="付款類型">
              <template slot-scope="{ row }">
                <span>{{ row.type | paymentType }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="upgradedType" label="升級狀態">
              <template slot-scope="{ row }">
                <div v-if="!row.upgradedAt && row.gradeName == '小六'">--</div>
                <div v-else>
                  <span>{{ row.upgradedAt | formatDate }}</span><span>{{setUpgradedTypeLabel(row.upgradedType)}}</span> <span>{{ row.upgradedType | upgradedType }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  v-if="
                    (dateJudge(scope.row.startDate, scope.row.endDate) == 2 ||
                      dateJudge(scope.row.startDate, scope.row.endDate) == 3) &&
                    scope.$index == 0
                  "
                  size="medium"
                  @click="onEditorButton(scope.row)"
                  >編輯</el-button
                >
                <el-button
                  type="text"
                  v-if="
                    ((dateJudge(scope.row.startDate, scope.row.endDate) == 2 ||
                      dateJudge(scope.row.startDate, scope.row.endDate) == 3) &&
                    scope.$index == 0) && scope.row.gradeName !== '小六'
                  "
                  size="medium"
                  @click="onUpgradesButton(scope.row.id)"
                  >升级</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="notice-box">
        <span class="text-line-button cursor-pointer" @click="onAddMore">
          <i class="el-icon-circle-plus-outline"></i>添加更多學生
        </span>
        <div>請註意：標有 (<span class="star-mark">*</span>) 的為必填項。</div>
      </div>
    </el-form>
    <dialogSlotVisible :centerDialogVisible="centerDialogVisible">
      <account-information-dialog :dialogTitle="dialogTitle" ref="formLabelAlignRef" :grades="grades" :formLabelAlign="formLabelAlign"></account-information-dialog>
      <div class="page-button">
        <el-button type="info" @click="onSubmit">提交</el-button>
        <el-button type="success" @click="onBack">取消</el-button>
      </div>
    </dialogSlotVisible>
  </div>
</template>

<script>
import accountInformationDialog from './accountInformationDialog.vue';
import subscriptionStatus from './subscriptionStatus.vue';
import moment from "moment";
import {
  addSubscription,
  putSubscription,
  subscriptionUpgradeRequest,
} from "@/api/subscription";
import dialogSlotVisible from "@/components/dialogSlotVisible";
import {getAvatars, deleteUser, putEditStudent} from "@/api/users";
import AvatarPopover from './avatarPopover.vue';
import {getGrades} from '@/api/grade'
export default {
  components: {accountInformationDialog, dialogSlotVisible,AvatarPopover,subscriptionStatus },
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      default: function () {},
    },
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请輸入密码"));
      } else {
        if (this.form.confirmPassword !== "") {
          this.$refs.form.validateField("confirmPassword");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次輸入密码"));
      } else if (this.form.confirmPassword != this.form.password) {
        callback(new Error("Not the same as the password.和密碼不相同。"));
      } else {
        callback();
      }
    };
    return {
      pickerOptions: {
                disabledDate(time) {
                  return time.getTime() > Date.now() - 8.64e7; 
                }
        },
      options:[
        {
          value: 1,
          label: '生效'
        },
        {
          value: 0,
          label: '封鎖'
        },
      ],
      showConfirmPassword: false,
      showPassword: false,
      isEditSubscribe: false,
      dialogTitle: "新增訂閱",
      studentId: 0,
      formLabelAlign: {
        id: null,
        studentId: null,
        gradeId: null,
        type: null,
        startDate: null,
        endDate: null,
        date: "",
        upgradeWill: null,
        subscribeStatus: null,
        upgradedAt: null,
        upgradedType: null,
      },
      centerDialogVisible: false,
      value: "",
      visible: false,
      students: [
        {
          userNo: null,
          name: null,
          gender: null,
          branchSchool: {
            id: null,
            name: {
              en: null,
              zhTc: null,
            },
            abbreviation: null,
          },
          password: null,
          confirmPassword: null,
          status:1,
          subscription: [],
          grade: {
            name: null,
            price: 0,
          },
          avatar: null,
          birthday: null,
          studentCode: null,
        },
      ],
      roles: [],
      statuses: [],
      grades: [],
      rules: {
        username: [
          {
            required: true,
            message: "The username must be at least 4 digits.用戶名称至少4位。",
            trigger: "change",
          },
          {
            min: 4,
            message: "The username must be at least 4 digits.用戶名称至少4位。",
            trigger: "blur",
          },
        ],
        email: [
          { required: true, message: "请輸入电邮", trigger: "change" },
          {
            type: "email",
            required: true,
            message: "Incorrect format.格式不正確。",
            trigger: "change",
          },
        ],
        password: [
          { required: true, message: "", trigger: "blur" },
          { validator: validatePass, trigger: "blur" },
          {
            min: 8,
            message: "The password must be at least 8 digits.密碼至少8位。",
            trigger: "blur",
          },
        ],
        confirmPassword: [
          { required: true, message: "", trigger: "blur" },
          { validator: validatePass2, trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.getGrades()
  },
  methods: {
  
    getGrades(){
      getGrades().then((res)=>{
         this.grades = res.data
      })
    },
    onStudentsStatus(index,status){
       this.form.students[index].status = status
       this.$forceUpdate()
    },
    onStatusChange(status){
      let that =this
      if(this.form.students.length > 0){ 
              that.form.students.forEach((item)=>{
                 item.status = status
                 that.$set(that.form.students,'status',item)
              })
             
              this.$forceUpdate()
      }
    },
    setUpgradedTypeLabel(type){
         switch (type) {
          case 1:
            return "學生滿星";
          case 2:
            return "在後台";
         }
    },
    avatarChange(index,avatar){
      this.form.students[index].avatar = avatar
      this.$forceUpdate()
    },
    onBranchSchoolChange(){
      this.$forceUpdate()
    },
    onEditorButton(row) {
      this.isEditSubscribe = true;
      this.formLabelAlign = Object.assign({},row);
      this.dialogTitle = "編輯訂閱";
      this.centerDialogVisible = true;
    },
    onUpgradesButton(id) {
      this.subscriptionUpgradeRequest(id);
    },
    onConfirmPassword() {
      this.$forceUpdate();
    },
    getThreeMonthAgo(endDate) {
      var a = moment();
      var b = moment(endDate);
      return b.diff(a, "months");
    },
    dateJudge(startDate, endDate) {
      let status = 0;
      let startDates=moment(startDate).format('YYYY-MM-DD')
      let endDates=moment(endDate).format('YYYY-MM-DD')
      let nowDate=moment().format('YYYY-MM-DD')
      if (nowDate <startDates) {
        // status = 1;
        return  status = 1
      }else if (nowDate == endDates) {
        // status = 4;
        return status = 4;
      } else  if (nowDate > endDates) {
        // status = 5;
        return status = 5;
      } else  if (this.getThreeMonthAgo(endDate) <= 3 && nowDate >= startDates) {
        // status = 3;
        return status = 3;
      }  else   if (nowDate >= startDates && nowDate < endDates) {
        // status = 2;
        return status = 2;
      }
      return status;
    },
    onSubmit() {
      this.$refs.formLabelAlignRef.$refs.formLabelAlignRef.validate((valid) => {
        if (valid) {
          if (this.isEditSubscribe) {
            this.putSubscription();
          } else {
            this.addSubscription();
          }
        }
      })
    },
    onBack() {
      this.centerDialogVisible = false;
    },
    onAddSubscribe(item) {
      Object.keys(this.formLabelAlign).forEach((key) => {
        this.formLabelAlign[key] = null;
      })
      this.isEditSubscribe = false;
      this.studentId = item.id;
      this.centerDialogVisible = true;
      this.$nextTick(()=>{
        this.$refs.formLabelAlignRef.$refs.formLabelAlignRef.clearValidate();
      })
    },
    onDelete(id, index) {
      if (id != undefined) {
        this.deleteUser(id);
      } else {
        this.form.students.splice(index, 1);
      }
    },
    onSave(item) {
      item.roleId = 5;
      if(item.studying == null){
        item.studying = 0;
      }
      if(item.parentId == null){
        item.parentId = this.formLabelAlign.id;
      }
      putEditStudent(item).then(() => {
        this.$message.success("保存成功");
      });
      console.info(item)
    },
    onSave1(item) {
      item.roleId = 5;
      if(item.studying == null){
        item.studying = 0;
      }
      if(item.parentId == null){
        item.parentId = this.formLabelAlign.id;
      }
      putEditStudent(item).then(() => {
        this.$message.success("修改成功");
      });
      console.info(item)
    },
    onAddMore() {
      let newStu = {
        userNo: null,
        name: null,
        gender: null,
        status: 1,
        branchSchool: {
          id:null,
          name: {
            en: null,
            zhTc: null,
          },
          abbreviation: null,
        },
        password: null,
        confirmPassword: null,
        grade: {
          id:null,
          name: null,
          price: 0,
        },
        subscriptions: [],
        avatar: null,
        birthday: null,
        studentCode: null,
      };

      this.form.students.push(newStu);
    },
    deleteUser(id) {
      deleteUser(id).then(() => {
        this.$emit("addSubscription");
      });
    },
    putSubscription() {
      putSubscription(this.formLabelAlign.id, this.formLabelAlign)
        .then(() => {this.$emit("addSubscription");})
        .finally(() => {
          this.centerDialogVisible = false;
        });
    },
    addSubscription() {
      this.formLabelAlign.id = this.form.id;
      this.formLabelAlign.studentId = this.studentId;
      addSubscription(this.formLabelAlign)
        .then(() => {
          this.$emit("addSubscription");
        })
        .finally(() => {
          this.centerDialogVisible = false;
        });
    },
    subscriptionUpgradeRequest(id) {
      subscriptionUpgradeRequest(id).then(() => {
        //弹出消息
        this.$message({
          message: "訂閱升级成功",
          type: "success",
        });
        this.$emit("addSubscription");
      });
    },
    getAvatars() {
      getAvatars().then((v) => {
        this.avatars = v.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.label-text {
  font-size: 20px;
  line-height: 24px;
}

.fixed-with-330-input {
  width: 100% !important;
}
.fixed-with-430-input {
  width: 430px !important;
}

.fixed-with-141-input {
  width: 141px;
}
.student-account-information-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 10px;
  margin-bottom: 20px;
}
.student-account-information-title-text {
  font-size: 22px;
  color: #b62d2e;
  font-weight: bold;
}
.notice-box {
  margin-top: 20px;
  border-top: 1px solid;
  padding-top: 20px;
}
.student-account-information-row {
  margin-bottom: 20px;
}
.subscribe-box {
  margin-top: 20px;
}
.subscribe-title {
  margin-bottom: 20px;
  color: #b62d2e;
  font-size: 20px;
}
.page-button {
  margin-top: 20px;
}
.flex-form-item {
  flex: 1;
}
::v-deep {
  .el-input__inner {
    height: 53px;
  }
  .el-select {
    width: 100%;
  }
  .el-select-phone {
    width: 100px;
  }
  .el-form-item__content {
    line-height: 24px;
  }
  .el-radio {
    text-align: center;
  }
  .el-radio__label {
    display: block;
    padding: 0;
  }
  .password-hidden {
    .el-input__inner {
      -webkit-text-security: disc !important;
    }
  }
}

.el-form-items {
  margin-bottom: 22px;
}
.form-avatar {
  position: relative;
  width: 40px;
  height: 40px;
}
.rowStatus-text-subscribing{
  color: #399500;
}
.rowStatus-text-status{
  color: #FF0000;
}
</style>